export default "__VITE_ASSET__C_js$0NF__"